<div [formGroup]="form">
    <mat-form-field style="width:100%;">
        <mat-label *ngIf="show">{{label}}</mat-label>
        <input matInput [formControlName]="name" [placeholder]="label" [matDatepicker]="date" (dateChange)="changeDatePicker();">
        <!-- <mat-hint>MM/YYYY</mat-hint> -->
        <mat-datepicker-toggle matSuffix [for]="date"></mat-datepicker-toggle>
        <mat-datepicker #date startView="year" startView="multi-year" (monthSelected)="setMonthAndYear($event, date)"></mat-datepicker>
        <mat-error *ngIf="show && form && form.get(name).hasError('required')">
            {{label}} est <strong>requise</strong>
        </mat-error>
    </mat-form-field>
</div>